/**
 * Create a page for all wpPage nodes automatically via
 * filesystem routing: https://www.gatsbyjs.com/docs/reference/routing/file-system-route-api/
 */
import * as React from "react"
import MainLayout from "../layouts/main"
import WordpressContent, {
  SecondaryWordpressContent,
} from "../components/wordpress-content"
import PtsCourseSections from "../components/pts-course-sections"
import IWpMenuItem from "../interfaces/IWpMenuItem"
import Link from "../components/link"

interface IPtsCourseProps extends Queries.PtsCoursePageQuery {
  localMenuItem: IWpMenuItem
  breadcrumbs: string | null
}

interface IContactInfo {
  email: string
  phone: string | null
  link: string | null
}

export default function PtsCourse(props: IPtsCourseProps): JSX.Element {
  const course = props.ptsCourse
  const localMenuItem = props.localMenuItem
  const breadcrumbs = props.breadcrumbs

  const contactInfo: IContactInfo = {
    email: `coned@georgiancollege.ca`,
    phone: null,
    link: `/academics/part-time-studies/contact-us/`,
  }

  if (course?.OntarioLearn) {
    contactInfo.email = `ol@georgiancollege.ca`
    contactInfo.phone = `705.722.1500`
    contactInfo.link = null
  } else if (
    course?.area === `Motorcycle+and+Transportation` &&
    course?.Number !== `0005` &&
    course?.Number !== `0036`
  ) {
    contactInfo.email = `Jenn.martin@georgiancollege.ca`
    contactInfo.phone = `249.388.1382`
    contactInfo.link = null
  }

  // const html =
  //   page?.content?.replace(
  //     /href="https:\/\/(www.georgiancollege.ca|www.gcblueprint.local|georgiangatsby.wpengine.com)\//gim,
  //     `href="/`
  //   ) || ``

  return (
    <>
      {/* <Seo
         title={page?.seo?.title || page?.title}
         description={page?.seo?.metaDesc}
         jsonld={page?.seo?.schema?.raw}
       /> */}
      <MainLayout
        localMenuItem={localMenuItem}
        breadcrumbs={breadcrumbs}
        ptsCourse={true}
      >
        <div>
          <h1 className="text-4xl text-blue">{course?.Title}</h1>
          <h2>
            {course?.Code || course?.SubjectCode}
            {` `}
            {course?.Number || course?.CourseNumber}
          </h2>
          <div className="flex flex-col lg:flex-row gap-4">
            <section className="w-full lg:w-8/12">
              {course?.wpPtsCourse?.content && (
                <WordpressContent html={course.wpPtsCourse.content} />
              )}

              {course?.Code === `PHTO` &&
                course?.Number === `0054` &&
                (course?.wpPtsCourse?.content === undefined ||
                  course?.wpPtsCourse?.content === null) && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `<p><strong>The course is scheduled to run Tuesday evenings from 7 to 10 p.m. between July 18 and Aug. 15, with a field trip on Saturday, Aug. 12.</strong></p><p><strong>ADDITIONAL INFORMATION:</strong></p> <p>It is strongly recommended that students complete or begin to complete PHTO0025 Digital Camera Techniques, or have a firm understanding of their cameras’ technical capabilities, before taking other courses. Students are required to use their personal camera.</p>`,
                    }}
                  ></div>
                )}

              {course?.Description && (
                <p>
                  {course?.wpPtsCourse?.content ? (
                    <SecondaryWordpressContent html={course.Description} />
                  ) : (
                    <WordpressContent html={course.Description} />
                  )}
                  {` `}
                </p>
              )}

              <div className="flex gap-4">
                <div className="w-1/2">
                  <h3>Credits</h3>
                  <p>{course?.outline?.CreditHourLow}</p>
                </div>
                <div className="w-1/2">
                  <h3>Course Hours</h3>
                  <p>{course?.outline?.ContactHourLow}</p>
                </div>
              </div>

              {course?.outline?.Prerequisites && (
                <div>
                  <h3>Prerequisites</h3>
                  <SecondaryWordpressContent
                    html={course.outline.Prerequisites}
                  />
                </div>
              )}

              {course?.outline?.Corequisites &&
                course?.outline?.Corequisites?.length > 0 && (
                  <div>
                    <h3>Corequisites</h3>
                    <ul>
                      {course?.outline?.Corequisites.map(
                        (corequisite, index) => (
                          <li key={index}>
                            {corequisite.SubjectCode} {corequisite.CourseNumber}
                            {` `}
                            {corequisite.Title}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}

              {/* {course?.Equivalents && (
                <div>
                  <h3>Equivalents</h3>
                  <ul>
                    {course.Equivalents.map(equivalent => (
                      <li key={equivalent?.CourseNumber}>
                        {equivalent?.SubjectCode} {equivalent?.CourseNumber}
                        {` `}
                        {equivalent?.Title}
                      </li>
                    ))}
                  </ul>
                </div>
              )} */}

              {parseInt(course?.outline?.CreditHourLow || `0`, 10) > 0 && (
                <p>
                  Students registering for credit courses for the first time
                  must declare a program at the point of registration. Declaring
                  a program does not necessarily mean students must complete a
                  program, individual courses may be taken for skill improvement
                  and upgrading.
                </p>
              )}

              {course?.customFields?.pts_content_after && (
                <SecondaryWordpressContent
                  html={course.customFields.pts_content_after}
                />
              )}

              {contactInfo.link ? (
                <p className="font-bold">
                  For more information, please{` `}
                  <a
                    href={`${contactInfo.link}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    contact Continuing Education
                  </a>
                </p>
              ) : (
                <p className="font-bold">
                  <>Contact </>
                  <a
                    href={`mailto:${contactInfo.email}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {contactInfo.email}
                  </a>
                  {contactInfo.phone && (
                    <>
                      <> or call </>
                      <a href={`tel:${contactInfo.phone.replace(/\./g, ``)}`}>
                        {contactInfo.phone}
                      </a>
                    </>
                  )}
                  <> for more information.</>
                </p>
              )}
              {course?.OntarioLearn && (
                <Link
                  to="/academics/online-learning/"
                  external
                  title="OntarioLearn"
                  className="inline-block bg-green px-4 py-2 text-white hover:bg-blue"
                >
                  <span className="icon-lp-ontariolearn"></span> OntarioLearn
                  information
                </Link>
              )}
            </section>
            <aside className="w-full lg:w-4/12">
              <h1 className="text-teal text-xl">Available Courses</h1>
              {course?.OntarioLearn ? (
                <p className="text-xs leading-5">
                  Unless stated, the course fee does NOT include the
                  textbook(s). OntarioLearn textbooks can be ordered online
                  through{` `}
                  <a
                    href="http://www.textnet.ca"
                    title="Textnet"
                    target="_blank"
                    rel="noreferrer"
                  >
                    www.textnet.ca
                  </a>
                  <br />
                  <br />
                  Confirmation letters for each OntarioLearn course is sent to
                  your Georgian{` `}
                  <a
                    href="http://mail.georgiancollege.ca/"
                    title="Georgian College Student Email"
                    target="_blank"
                    rel="noreferrer"
                  >
                    student email
                  </a>
                  {` `}
                  with information on how to log in to your course. OntarioLearn
                  courses are not available through Georgian's BlackBoard.
                </p>
              ) : (
                <p className="text-xs">
                  Unless stated, the course fee does NOT include the
                  textbook(s). Not all courses have required textbooks. See{` `}
                  <a
                    href="//www.georgiancollege.ca/academics/part-time-studies/information-centre/registration-deadlines/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    registration dates
                  </a>
                  {` `}
                  for courses that are not yet open.
                </p>
              )}
              {course?.Code === `LKEY` && (
                <p className="text-xs">
                  This is a self-paced, independent learning module delivered
                  online. Registration remains open until the end date
                  displayed.
                </p>
              )}
              {course?.Code && course?.Number && (
                <PtsCourseSections
                  code={course?.Code}
                  number={course?.Number}
                />
              )}
            </aside>
          </div>
        </div>
      </MainLayout>
    </>
  )
}
